import React from 'react';

import { SVGComponentProps } from './svg.types';

const AiCreateButtonSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="179"
        height="30"
        viewBox="0 0 179 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <g filter="url(#filter0_dii_265_3631)">
          <rect x="1" y="1" width="177" height="28" rx="14" fill="white" />
          <path
            d="M17.2928 9.55589C17.4726 8.81449 18.5271 8.81449 18.7068 9.55589L19.2015 11.5959C19.2657 11.8606 19.4724 12.0673 19.7371 12.1315L21.7771 12.6262C22.5185 12.8059 22.5185 13.8604 21.7771 14.0402L19.7371 14.5349C19.4724 14.599 19.2657 14.8057 19.2015 15.0704L18.7068 17.1104C18.5271 17.8519 17.4726 17.8519 17.2928 17.1104L16.7982 15.0704C16.734 14.8057 16.5273 14.599 16.2626 14.5349L14.2226 14.0402C13.4812 13.8604 13.4812 12.8059 14.2226 12.6262L16.2626 12.1315C16.5273 12.0673 16.734 11.8606 16.7982 11.5959L17.2928 9.55589Z"
            fill="url(#paint0_linear_265_3631)"
          />
          <path
            d="M23.2314 16.6754C23.3421 16.2191 23.991 16.2191 24.1016 16.6754L24.406 17.9308C24.4455 18.0937 24.5727 18.2208 24.7356 18.2603L25.991 18.5648C26.4472 18.6754 26.4472 19.3243 25.991 19.4349L24.7356 19.7393C24.5727 19.7788 24.4455 19.906 24.406 20.0689L24.1016 21.3243C23.991 21.7806 23.3421 21.7806 23.2314 21.3243L22.927 20.0689C22.8875 19.906 22.7603 19.7788 22.5974 19.7393L21.342 19.4349C20.8858 19.3243 20.8858 18.6754 21.342 18.5648L22.5974 18.2603C22.7603 18.2208 22.8875 18.0937 22.927 17.9308L23.2314 16.6754Z"
            fill="url(#paint1_linear_265_3631)"
          />
          <path
            d="M25.381 9.4744C25.4536 9.17498 25.8794 9.17498 25.952 9.4744L26.1518 10.2983C26.1777 10.4052 26.2612 10.4886 26.3681 10.5145L27.1919 10.7143C27.4914 10.7869 27.4914 11.2128 27.1919 11.2854L26.3681 11.4851C26.2612 11.5111 26.1777 11.5945 26.1518 11.7014L25.952 12.5253C25.8794 12.8247 25.4536 12.8247 25.381 12.5253L25.1812 11.7014C25.1553 11.5945 25.0718 11.5111 24.9649 11.4851L24.1411 11.2854C23.8417 11.2128 23.8417 10.7869 24.1411 10.7143L24.9649 10.5145C25.0718 10.4886 25.1553 10.4052 25.1812 10.2983L25.381 9.4744Z"
            fill="url(#paint2_linear_265_3631)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.6665 9.62057L25.5035 10.293C25.4383 10.5618 25.2284 10.7716 24.9596 10.8368L24.2872 10.9998L24.9596 11.1629C25.2284 11.2281 25.4383 11.4379 25.5035 11.7067L25.6665 12.3791L25.8296 11.7067C25.8947 11.4379 26.1046 11.2281 26.3734 11.1629L27.0458 10.9998L26.3734 10.8368C26.1046 10.7716 25.8947 10.5618 25.8296 10.293L25.6665 9.62057ZM25.9928 9.25648C25.9098 8.91429 25.4232 8.91429 25.3402 9.25648L25.1119 10.198C25.0823 10.3202 24.9869 10.4156 24.8647 10.4452L23.9231 10.6735C23.581 10.7565 23.581 11.2432 23.9231 11.3261L24.8647 11.5545C24.9869 11.5841 25.0823 11.6795 25.1119 11.8016L25.3402 12.7432C25.4232 13.0854 25.9098 13.0854 25.9928 12.7432L26.2211 11.8016C26.2508 11.6795 26.3461 11.5841 26.4683 11.5545L27.4099 11.3261C27.7521 11.2432 27.7521 10.7565 27.4099 10.6735L26.4683 10.4452C26.3461 10.4156 26.2508 10.3202 26.2211 10.198L25.9928 9.25648Z"
            fill="url(#paint3_linear_265_3631)"
          />
          <path
            d="M17.6665 22.3332C17.2983 22.3332 16.9998 22.0347 16.9998 21.6665C16.9998 21.2983 17.2983 20.9998 17.6665 20.9998C18.0347 20.9998 18.3332 21.2983 18.3332 21.6665C18.3332 22.0347 18.0347 22.3332 17.6665 22.3332Z"
            fill="url(#paint4_linear_265_3631)"
          />
          <path
            d="M14.3332 19.6665C13.965 19.6665 13.6665 19.368 13.6665 18.9998C13.6665 18.6316 13.965 18.3332 14.3332 18.3332C14.7014 18.3332 14.9998 18.6316 14.9998 18.9998C14.9998 19.368 14.7014 19.6665 14.3332 19.6665Z"
            fill="url(#paint5_linear_265_3631)"
          />
          <path
            d="M21.6665 8.99984C21.2983 8.99984 20.9998 8.70136 20.9998 8.33317C20.9998 7.96498 21.2983 7.6665 21.6665 7.6665C22.0347 7.6665 22.3332 7.96498 22.3332 8.33317C22.3332 8.70136 22.0347 8.99984 21.6665 8.99984Z"
            fill="url(#paint6_linear_265_3631)"
          />
          <path
            d="M27.6665 16.3332C27.2983 16.3332 26.9998 16.0347 26.9998 15.6665C26.9998 15.2983 27.2983 14.9998 27.6665 14.9998C28.0347 14.9998 28.3332 15.2983 28.3332 15.6665C28.3332 16.0347 28.0347 16.3332 27.6665 16.3332Z"
            fill="url(#paint7_linear_265_3631)"
          />
          <path
            d="M38.53 19.14C35.394 19.14 33.644 17.138 33.644 14.058V13.946C33.644 10.936 35.716 8.836 38.502 8.836C40.798 8.836 42.576 9.984 42.8 12.336H40.91C40.7 11.006 39.958 10.32 38.516 10.32C36.752 10.32 35.604 11.692 35.604 13.932V14.044C35.604 16.298 36.682 17.628 38.53 17.628C39.916 17.628 40.896 16.928 41.092 15.514H42.912C42.618 17.922 40.91 19.14 38.53 19.14ZM44.385 19V11.678H46.079V13.05C46.541 12.126 47.227 11.58 48.459 11.566V13.148C46.975 13.162 46.079 13.638 46.079 15.192V19H44.385ZM53.0327 19.14C50.8767 19.14 49.3227 17.726 49.3227 15.416V15.304C49.3227 13.036 50.8767 11.524 52.9627 11.524C54.7827 11.524 56.4207 12.602 56.4207 15.22V15.71H51.0587C51.1147 17.096 51.8147 17.88 53.0747 17.88C54.0967 17.88 54.6287 17.474 54.7547 16.76H56.3927C56.1547 18.3 54.9087 19.14 53.0327 19.14ZM51.0867 14.576H54.7407C54.6567 13.316 54.0127 12.756 52.9627 12.756C51.9407 12.756 51.2547 13.442 51.0867 14.576ZM59.9201 19.14C58.5761 19.14 57.4701 18.496 57.4701 16.97C57.4701 15.262 59.1221 14.646 61.2221 14.646H62.1321V14.268C62.1321 13.288 61.7961 12.798 60.8021 12.798C59.9201 12.798 59.4861 13.218 59.4021 13.946H57.7641C57.9041 12.238 59.2621 11.524 60.9001 11.524C62.5381 11.524 63.8261 12.196 63.8261 14.198V19H62.1601V18.104C61.6841 18.734 61.0401 19.14 59.9201 19.14ZM60.3261 17.922C61.3621 17.922 62.1321 17.376 62.1321 16.438V15.71H61.2641C59.9761 15.71 59.1501 16.004 59.1501 16.9C59.1501 17.516 59.4861 17.922 60.3261 17.922ZM68.2598 19.126C66.8038 19.126 66.0478 18.342 66.0478 16.956V12.952H65.0678V11.678H66.0478V10.068H67.7418V11.678H69.3518V12.952H67.7418V16.802C67.7418 17.446 68.0498 17.74 68.5818 17.74C68.9178 17.74 69.1698 17.698 69.4078 17.6V18.944C69.1418 19.042 68.7778 19.126 68.2598 19.126ZM74.1557 19.14C71.9997 19.14 70.4457 17.726 70.4457 15.416V15.304C70.4457 13.036 71.9997 11.524 74.0857 11.524C75.9057 11.524 77.5437 12.602 77.5437 15.22V15.71H72.1817C72.2377 17.096 72.9377 17.88 74.1977 17.88C75.2197 17.88 75.7517 17.474 75.8777 16.76H77.5157C77.2777 18.3 76.0317 19.14 74.1557 19.14ZM72.2097 14.576H75.8637C75.7797 13.316 75.1357 12.756 74.0857 12.756C73.0637 12.756 72.3777 13.442 72.2097 14.576ZM84.8848 19.126C83.4288 19.126 82.6728 18.342 82.6728 16.956V12.952H81.6928V11.678H82.6728V10.068H84.3668V11.678H85.9768V12.952H84.3668V16.802C84.3668 17.446 84.6748 17.74 85.2068 17.74C85.5428 17.74 85.7948 17.698 86.0328 17.6V18.944C85.7668 19.042 85.4028 19.126 84.8848 19.126ZM89.5471 19.14C88.2031 19.14 87.0971 18.496 87.0971 16.97C87.0971 15.262 88.7491 14.646 90.8491 14.646H91.7591V14.268C91.7591 13.288 91.4231 12.798 90.4291 12.798C89.5471 12.798 89.1131 13.218 89.0291 13.946H87.3911C87.5311 12.238 88.8891 11.524 90.5271 11.524C92.1651 11.524 93.4531 12.196 93.4531 14.198V19H91.7871V18.104C91.3111 18.734 90.6671 19.14 89.5471 19.14ZM89.9531 17.922C90.9891 17.922 91.7591 17.376 91.7591 16.438V15.71H90.8911C89.6031 15.71 88.7771 16.004 88.7771 16.9C88.7771 17.516 89.1131 17.922 89.9531 17.922ZM97.9007 19.14C96.0107 19.14 94.9047 18.272 94.8347 16.718H96.4307C96.5147 17.46 96.8927 17.894 97.8867 17.894C98.7967 17.894 99.2027 17.572 99.2027 16.956C99.2027 16.354 98.7127 16.13 97.6347 15.948C95.7027 15.64 94.9887 15.094 94.9887 13.722C94.9887 12.252 96.3607 11.524 97.7327 11.524C99.2307 11.524 100.421 12.084 100.603 13.736H99.0347C98.8947 13.064 98.5167 12.756 97.7327 12.756C97.0047 12.756 96.5707 13.106 96.5707 13.624C96.5707 14.156 96.9207 14.366 98.0827 14.562C99.8047 14.828 100.827 15.248 100.827 16.802C100.827 18.286 99.7767 19.14 97.9007 19.14ZM102.313 19V8.29H104.007V14.898L106.625 11.678H108.473L105.631 15.038L108.711 19H106.751L104.007 15.402V19H102.313ZM112.243 19.14C110.353 19.14 109.247 18.272 109.177 16.718H110.773C110.857 17.46 111.235 17.894 112.229 17.894C113.139 17.894 113.545 17.572 113.545 16.956C113.545 16.354 113.055 16.13 111.977 15.948C110.045 15.64 109.331 15.094 109.331 13.722C109.331 12.252 110.703 11.524 112.075 11.524C113.573 11.524 114.763 12.084 114.945 13.736H113.377C113.237 13.064 112.859 12.756 112.075 12.756C111.347 12.756 110.913 13.106 110.913 13.624C110.913 14.156 111.263 14.366 112.425 14.562C114.147 14.828 115.169 15.248 115.169 16.802C115.169 18.286 114.119 19.14 112.243 19.14ZM121.502 19L119.262 11.678H121.068L122.524 16.97L124.078 11.678H125.492L126.92 16.97L128.446 11.678H130.098L127.802 19H126.08L124.722 14.072L123.238 19H121.502ZM131.435 19V11.678H133.129V19H131.435ZM132.261 10.474C131.701 10.474 131.253 10.054 131.253 9.508C131.253 8.948 131.701 8.528 132.261 8.528C132.821 8.528 133.269 8.948 133.269 9.508C133.269 10.054 132.821 10.474 132.261 10.474ZM137.686 19.126C136.23 19.126 135.474 18.342 135.474 16.956V12.952H134.494V11.678H135.474V10.068H137.168V11.678H138.778V12.952H137.168V16.802C137.168 17.446 137.476 17.74 138.008 17.74C138.344 17.74 138.596 17.698 138.834 17.6V18.944C138.568 19.042 138.204 19.126 137.686 19.126ZM140.362 19V8.29H142.056V12.84C142.406 12.126 143.218 11.524 144.422 11.524C145.892 11.524 146.928 12.378 146.928 14.394V19H145.234V14.548C145.234 13.442 144.786 12.938 143.778 12.938C142.826 12.938 142.056 13.526 142.056 14.688V19H140.362ZM151.585 19L154.931 8.99H157.367L160.671 19H158.739L157.941 16.522H154.119L153.335 19H151.585ZM156.037 10.516L154.553 15.164H157.507L156.037 10.516ZM162.255 19V8.99H164.131V19H162.255Z"
            fill="url(#paint8_linear_265_3631)"
          />
        </g>
        <defs>
          <filter
            id="filter0_dii_265_3631"
            x="0"
            y="0"
            width="179"
            height="30"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="1"
              operator="dilate"
              in="SourceAlpha"
              result="effect1_dropShadow_265_3631"
            />
            <feOffset />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0117647 0 0 0 0 0.027451 0 0 0 0 0.0705882 0 0 0 0.08 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_265_3631" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_265_3631"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="2"
              operator="erode"
              in="SourceAlpha"
              result="effect2_innerShadow_265_3631"
            />
            <feOffset />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0 0.921569 0 0 0 0.4 0"
            />
            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_265_3631" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="1"
              operator="erode"
              in="SourceAlpha"
              result="effect3_innerShadow_265_3631"
            />
            <feOffset />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
            <feBlend
              mode="normal"
              in2="effect2_innerShadow_265_3631"
              result="effect3_innerShadow_265_3631"
            />
          </filter>
          <linearGradient
            id="paint0_linear_265_3631"
            x1="13.1262"
            y1="2.53317"
            x2="29.17"
            y2="3.23619"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_265_3631"
            x1="13.1262"
            y1="2.53317"
            x2="29.17"
            y2="3.23619"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_265_3631"
            x1="13.1262"
            y1="2.53317"
            x2="29.17"
            y2="3.23619"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_265_3631"
            x1="13.1262"
            y1="2.53317"
            x2="29.17"
            y2="3.23619"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_265_3631"
            x1="13.1262"
            y1="2.53317"
            x2="29.17"
            y2="3.23619"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_265_3631"
            x1="13.1262"
            y1="2.53317"
            x2="29.17"
            y2="3.23619"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_265_3631"
            x1="13.1262"
            y1="2.53317"
            x2="29.17"
            y2="3.23619"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_265_3631"
            x1="13.1262"
            y1="2.53317"
            x2="29.17"
            y2="3.23619"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_265_3631"
            x1="28.1"
            y1="-2"
            x2="162.459"
            y2="37.1515"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
        </defs>
      </svg>
    </span>
  );
};

export default AiCreateButtonSVG;
